import { useEffect } from "react";

export default function useEscapeKeypress(conditional: boolean, callback: () => unknown) {
  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && conditional) {
        callback();
      }
    };

    window.addEventListener("keydown", handleEscapeKey);
    return () => window.removeEventListener("keydown", handleEscapeKey);
  }, [callback, conditional]);
}
